<template lang="pug">
.cp-audio-list
  .title 客户案例
  .list-wrap
    .item-wrap(v-for="(v, index) in list", :key="index", :class="{ 'active-item': index === activeIndex }")
      .item-box
        audio-progress.audioProgress(ref="audio-progress", v-if="index === activeIndex", :percent="0")
        span.num.fontA(v-else) 0{{ index + 1 }}
        span.label {{ v.label }}
        .right.fr
          span.text 试听
          .pauseIcon(v-if="index === activeIndex", @click="pause")
          .playIcon(v-else, @click="play(index)")
          span {{ index === activeIndex ? currentTime : v.duration | formateDuration }}
  audio(ref="audio", :src="audioUrl")
</template>
<script>
import { formateTime } from '@/common/utils.js'

export default {
  components: {},
  props: {},
  filters: {
    formateDuration (value) {
      return formateTime(value * 1000)
    }
  },
  data () {
    return {
      activeIndex: -1,
      list: [
        { label: '金融行业流程跟进', src: '1.mp3', duration: 135.36 },
        { label: '教育行业试听课邀约', src: '2.mp3', duration: 93.38 },
        { label: '保险行业寿险营销', src: '3.mp3', duration: 88.86 },
        { label: '房产开发商新盘推介', src: '4.mp3', duration: 92.68 },
        { label: '跨境电商展会邀约(人工转接)', src: '5.mp3', duration: 234.18 },
        { label: '传媒行业广告位开户', src: '6.mp3', duration: 78.3 },
        { label: '旅游分期产品(人工转接)', src: '7.mp3', duration: 175.34 },
        { label: '少儿培训试听课邀约', src: '8.mp3', duration: 48 },
      ],
      audio: null,
      timer1: null,
      currentTime: 0
    }
  },
  computed: {
    audioUrl () {
      return this.activeIndex === -1 ? '' : this.list[this.activeIndex].src
    }
  },
  mounted () {
    // this.initalAudios()
    this.audio = this.$refs.audio
    this.audio.addEventListener('ended', this.pause, false)
  },
  methods: {
    initalAudios () {
      this.list.forEach(v => {
        const audio = new Audio()
        audio.src = v.src
        audio.oncanplay = () => {
          v.duration = audio.duration
        }
      })
    },
    play (index) {
      if (this.$refs['audio-progress'] && this.$refs['audio-progress'][0]) {
        this.$refs['audio-progress'][0].end()
      }
      this.currentTime = 0
      this.activeIndex = index
      this.audio.oncanplay = () => {
        this.audio.play()
        this.currentTime = this.audio.currentTime
        this.$refs['audio-progress'][0].start(this.list[index].duration * 1000)
        this.timer1 = setInterval(() => {
          this.currentTime = this.audio.currentTime
        }, 1000)
      }
    },
    pause () {
      this.activeIndex = -1
      this.audio.pause()
      this.currentTime = 0
      if (this.$refs['audio-progress'] && this.$refs['audio-progress'][0]) {
        this.$refs['audio-progress'][0].end()
      }
      if (this.timer1) {
        clearInterval(this.timer1)
      }
    },
  },
  beforeDestroy () {
    this.pause()
    this.audio.removeEventListener('ended', this.pause)
  }
}
</script>
<style lang="stylus">
.cp-audio-list
  width 1012px
  margin 0 auto
  color #FFF
  padding-top 140px
  .list-wrap
    margin-top 55px
    margin-bottom 306px
    .item-wrap
      height 72px
      padding-left 32px
      padding-right 27px
      background rgba(8,27,65,0.9)
      border 2px solid rgba(21,35,82,1)
      display flex
      align-items center
      &:hover
        // background #0A204C
        background linear-gradient(270deg, rgba(50,109,214,1) 0%, rgba(70,179,228,1) 100%)
        span
          color #FFF !important
          // color #9EEAFA
      .item-box
        width 100%
        height 43px
        line-height 43px
        .audioProgress
          display inline-block
          margin-right 23px
          float left
        .fontA
          font-size 19px
          font-family Antonio-Regular,Antonio
          font-weight 400
          color rgba(68,192,205,1)
          margin-right 23px
        .label
          font-size 19px
          font-weight 400
        .right
          height 43px
          display flex
          justify-content space-between
          align-items center
          .playIcon
            margin 0px 22px
            width 43px
            height 43px
            background url('../../../assets/play.png') center / 100%
            cursor pointer
          .pauseIcon
            margin-left 27px
            margin-right 25px
            width 49px
            height 48px
            background url('../../../assets/pause.png') center / 100%
            cursor pointer
          span
            &:first-child
              font-size 14px
              font-weight 500
              color #FFF
            &:last-child
              font-size 20px
              color #808695
    .active-item
      transform translate(-26px)
      width 1068px
      height 87px
      background linear-gradient(270deg, rgba(50,109,214,1) 0%, rgba(70,179,228,1) 100%) !important
      .item-box
        .label
          font-size 24px
          font-weight 600
          color #FFF !important
        .right
          span:first-child
            font-size 16px
          span:last-child
            font-size 20px
            color #FFF
</style>
